import { useState } from "react";
import clsx from "clsx";
import { API_BASE } from "@/lib/apiClient";
import { useBranding } from "@/lib/branding/useBranding";
import { resolveBrandingAssetUrl } from "@shared/brandingAssetUrl";

type BrandingLogoProps = {
  className?: string;
  imgClassName?: string;
  /** Größe des Emoji-Fallbacks, wenn kein Logo hinterlegt ist */
  fallbackClassName?: string;
  alt?: string;
  logoUrl?: string | null;
  siteName?: string;
};

export function BrandingLogo({
  className,
  imgClassName,
  fallbackClassName = "text-2xl",
  alt,
  logoUrl: logoUrlProp,
  siteName: siteNameProp,
}: BrandingLogoProps) {
  const ctx = useBranding();
  const logoUrl = resolveBrandingAssetUrl(logoUrlProp ?? ctx.logoUrl, API_BASE);
  const siteName = siteNameProp ?? ctx.siteName;
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const label = alt ?? siteName;
  const showImage = Boolean(logoUrl) && failedUrl !== logoUrl;

  if (showImage && logoUrl) {
    return (
      <span className="inline-flex max-w-full shrink-0 overflow-hidden">
        <img
          src={logoUrl}
          alt=""
          className={clsx("object-contain", imgClassName ?? "h-8 max-w-[10rem]", className)}
          loading="eager"
          decoding="async"
          onError={() => setFailedUrl(logoUrl)}
        />
        {label ? <span className="sr-only">{label}</span> : null}
      </span>
    );
  }

  return (
    <span className={clsx("shrink-0", fallbackClassName, className)} aria-hidden>
      ⛺
    </span>
  );
}
